import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Text } from '../../../../../../../../../typography';
import { Grid } from '../../../../../../../../../layout/Grid';
import { useModal } from '../../../../../../../../../../store/modals';
import { useUpdateUserPermissions } from '../../../../../../../../../../services/user/update-permissions';
import { useUserPermissionsByEmail } from '../../../../../../../../../../services/user/permissions/permissions-by-email';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export function ManageAccessToServices() {
  const intl = useIntl();

  const {
    selectedUser,
    isPrimaryResidentAddress,
  } = useContext(UserAdministrationModalContext);
  const userPermissionsByEmail = useUserPermissionsByEmail(selectedUser && selectedUser.email);

  const { openModal } = useModal();

  const updateUserPermissions = useUpdateUserPermissions({ selectedUser });

  const handlePrimaryResidentChange = () => {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage({ id: 'changePrimaryResidentAddress' }),
        content: intl.formatMessage({
          id: 'changePrimaryResidentAddressContent',
        }, {
          selectedUserEmail: <strong>{selectedUser?.email}</strong>,
          aptId: <strong>{selectedUser?.addressId}</strong>,
        }),
        onConfirm: async () => {
          await updateUserPermissions.mutateAsync({
            userEmail: selectedUser?.email,
            permissions: {
              'admin-address': {
                read: true,
              },
            },
          });
        },
      },
    });
  };

  return (
    <Grid
      noPadding
      oneColumn
      className={styles.servicesContainer}
      justifyItems="start"
    >
      <Text
        size={20}
        fontWeight={700}
      >
        {intl.formatMessage({ id: 'accessToServices', defaultMessage: 'Access to services' })}
      </Text>

      <div className={styles.services}>
        {
          isPrimaryResidentAddress && !userPermissionsByEmail.isLoading ? (
            <FormattedMessage
              id="userIsPrimaryResident"
              values={{ aptId: <strong> {selectedUser?.addressId} </strong> }}
            />
          ) : (
            <div className={styles.deleteContainer}>
              <FormattedMessage
                id="userIsNotPrimaryResident"
                values={{ aptId: <strong> {selectedUser?.addressId} </strong> }}
              />
              <Button
                className={styles.deleteBtn}
                onClick={() => handlePrimaryResidentChange()}
              >{intl.formatMessage({ id: 'reassignPrimaryResident' })}
              </Button>
            </div>
          )
        }
      </div>
    </Grid>
  );
}
